import { render, staticRenderFns } from "./ProgramShow.vue?vue&type=template&id=9d0be02c&scoped=true&"
import script from "./ProgramShow.vue?vue&type=script&lang=ts&"
export * from "./ProgramShow.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramShow.vue?vue&type=style&index=0&id=9d0be02c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0be02c",
  null
  
)

export default component.exports